import React from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import Home from '../src/pages/Home'
import Servicebanner from './components/Ourservices/Servicebanner'
import Serviceforwarding from './pages/Serviceforwarding'
const Main = () => {
  return (
    <div>
      <HashRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Service/:name' element={<Serviceforwarding />} />
          {/* <Route path='/Serviceinspection' element={<Serviceinspection/>} />
          <Route path='/Servicetrading' element={<Servicetrading/>} />
          {/* <Route path='/Mission & Vission' element={<Mission />} />
          <Route path='/Team' element={<Team />} /> */}
        </Routes>
      </HashRouter>

    </div>
  )
}

export default Main
